<template>
  <div
    class="bbp-placeholder"
    :style="customStyle"
  >
    <div class="bbp-placeholder__image">
      <img src="@/assets/images/no-data-type2.png" alt="">
    </div>
    <div class="bbp-placeholder__title">
      {{ title }}
    </div>
    <div
      v-if="description1"
      class="bbp-placeholder__description"
    >
      {{ description1 }}
    </div>
    <div
      v-if="description2"
      class="bbp-placeholder__description"
    >
      {{ description2 }}
    </div>
    <div
      v-if="button"
      class="bbp-placeholder-button"
      @click.stop="onButtonClick"
    >
      <div
        class="bbp-placeholder-button__icon"
        v-html="plusIcon()"
      />
      <div class="bbp-placeholder-button__text">
        {{button}}
      </div>
    </div>
  </div>
</template>

<script>
import { PLUS_ICON } from '@/constants/icons'

export default {
  name: 'BBPPlaceholder',
  props: {
    title: {
      type: String,
      default: 'No data'
    },
    description1: {
      type: String,
      default: ''
    },
    description2: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    },
    customStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    plusIcon: PLUS_ICON
  }),
  methods: {
    onButtonClick () {
      this.$emit('onButtonClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-placeholder {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &__image {
      margin: 0 0 8px 0;

      img {
        width: 100%;
        height: 100%;
      }
    }

    &__title {
      margin: 0 0 3px 0;
      font-size: 14px;
      line-height: 17px;
      font-weight: 700;
      letter-spacing: 1px;
      color: $color-silver;
    }

    &__description {
      font-size: 12px;
      line-height: 15px;
      font-weight: 500;
      letter-spacing: 1px;
      color: $color-silver;
    }
  }

  .bbp-placeholder-button {
    width: 92px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0 0 0;
    border: 1px dashed $color-denim;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.2s;
    color: $color-denim;

    &__icon {
      margin: 0 8px 0 0;
    }

    &__text {
      font-size: 15px;
      line-height: 18px;
      font-weight: 600;
    }

    &:hover {
      opacity: 0.8;
    }
  }

</style>
<style lang="scss">
  .bbp-placeholder-button__icon {

    svg {
      width: 14px;
      height: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPPlaceholder/BBPPlaceholder.vue